import type { ReactNode } from 'react'
import { FeedSection } from './FeedSection'
import { PeopleSection } from './PeopleSection'
import { GroupsSection } from './GroupsSection'
import type { SetFeed } from '../../hooks/useSetPosts'
import type { Artist, Event, Group, Set as FestivalSet, UserProfile } from '../../types'

export function SocialView({
  groups,
  linkedGroups,
  onUnlinkGroup,
  canUnlinkGroup,
  isGuest,
  onCreateGroup,
  goingUserIds,
  interestedUserIds,
  peopleLoading,
  userProfiles,
  profilesLoading,
  currentUserId,
  friendIds,
  feed,
  artists,
  sets,
  hasSchedule,
  onNavigateToSet,
  eventId,
  event,
  topPicks,
}: {
  groups: Group[]
  linkedGroups: Group[]
  onUnlinkGroup: (groupId: string) => void
  canUnlinkGroup: (groupId: string) => boolean
  isGuest: boolean
  onCreateGroup: () => void
  goingUserIds: Set<string>
  interestedUserIds: Set<string>
  peopleLoading: boolean
  userProfiles: Record<string, UserProfile>
  profilesLoading: boolean
  currentUserId: string | null
  friendIds: string[]
  feed: SetFeed
  artists: Record<string, Artist>
  sets: FestivalSet[]
  hasSchedule: boolean
  onNavigateToSet: (set: FestivalSet) => void
  eventId: string
  event: Event | null
  /** The crew top picks section, built by the page from data SocialView doesn't otherwise need. */
  topPicks?: ReactNode
}) {
  return (
    <div className="flex flex-col gap-6">
      {topPicks}
      <FeedSection
        feed={feed}
        artists={artists}
        sets={sets}
        userProfiles={userProfiles}
        currentUserId={currentUserId}
        hasSchedule={hasSchedule}
        onNavigateToSet={onNavigateToSet}
        eventId={eventId}
      />
      <PeopleSection
        loading={peopleLoading}
        profilesLoading={profilesLoading}
        linkedGroups={linkedGroups}
        friendIds={friendIds}
        goingUserIds={goingUserIds}
        interestedUserIds={interestedUserIds}
        userProfiles={userProfiles}
        currentUserId={currentUserId}
      />
      <GroupsSection
        eventId={eventId}
        isFestival={event?.type !== 'party'}
        groups={groups}
        linkedGroups={linkedGroups}
        goingUserIds={goingUserIds}
        interestedUserIds={interestedUserIds}
        profiles={userProfiles}
        isGuest={isGuest}
        onUnlink={onUnlinkGroup}
        canUnlink={canUnlinkGroup}
        onCreateGroup={onCreateGroup}
      />
    </div>
  )
}
